import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Globe, Activity, Zap, Cpu, Loader2 } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGlobalPulse() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section data-section-id="8565" id="the-pulse" ref={ref} className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden flex flex-col items-center justify-center py-20">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--primary)_0%,transparent_40%)] opacity-20 blur-3xl" />
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626701/img/digital_grid_overlay.png')] opacity-10 bg-repeat mix-blend-overlay" />
      </div>

      {}
      <div className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none">
        <div className="relative w-[600px] h-[600px] md:w-[800px] md:h-[800px] lg:w-[1000px] lg:h-[1000px] flex items-center justify-center">
          
          {}
          <div className="absolute inset-0 border-2 border-primary/40 rounded-none animate-[spin_30s_linear_infinite]" />
          <div className="absolute inset-[10%] border-2 border-primary/20 rounded-none animate-[spin_45s_linear_infinite_reverse]" />
          <div className="absolute inset-[25%] border-2 border-dashed border-primary/50 rounded-none animate-[spin_20s_linear_infinite]" />
          
          {}
          <div className="relative w-[60%] h-[40%] rounded-none overflow-hidden shadow-[0_0_80px_var(--primary)] animate-pulse border-4 border-primary bg-background/80">
             <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-transparent to-primary/30 z-10 mix-blend-overlay" />
             <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626701/img/futuristic_earth_globe_high_res.png" alt="V-IRAL Atom Core" className="w-full h-full object-cover opacity-60 animate-[spin_120s_linear_infinite]" />
             {}
             <div className="absolute inset-0 flex items-center justify-center gap-12 z-20">
                <Zap className="w-24 h-24 text-primary drop-shadow-[0_0_15px_var(--primary)] animate-bounce" />
                <Zap className="w-24 h-24 text-primary drop-shadow-[0_0_15px_var(--primary)] animate-bounce delay-150" />
             </div>
          </div>

          {}
          {}
          <div className={`absolute top-[15%] right-[15%] transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <Card className="w-48 bg-background/60 backdrop-blur-none border-primary shadow-[0_0_20px_rgba(0,255,0,0.2)] rounded-none">
              <CardContent className="p-3 flex items-center gap-3">
                <Activity className="w-5 h-5 text-primary animate-pulse" />
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-muted-foreground font-default">GATEKEEPER STATUS</div>
                  <div className="text-xs font-bold text-primary font-default">ACTIVE</div>
                </div>
              </CardContent>
            </Card>
            {}
            <div className="absolute top-full left-1/2 w-px h-20 bg-gradient-to-b from-primary/50 to-transparent -z-10" />
          </div>

          {}

          {}

        </div>
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 text-center flex flex-col items-center">
        
        {}
        <h1 className={`font-default font-black text-6xl md:text-8xl lg:text-9xl tracking-tighter leading-[0.9] mb-8 mix-blend-screen text-primary transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          V‑IRAL
        </h1>

        {}
        <p className={`max-w-2xl text-lg md:text-xl text-muted-foreground mb-12 font-default tracking-wide transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}><br /></p>

        {}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50 animate-bounce">
          <span className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground font-default">Scroll to Scan</span>
          <div className="w-[1px] h-12 bg-gradient-to-b from-primary to-transparent" />
        </div>

        {}
        <div className={`transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <Button asChild size="lg" className="relative group bg-transparent hover:bg-primary/10 text-foreground px-10 py-8 text-lg tracking-widest overflow-hidden border-0 rounded-none">
            <Link to="#">
              {}
              <span className="absolute inset-0 rounded-none p-[2px] bg-gradient-to-r from-primary via-primary/50 to-primary bg-[length:200%_100%] animate-[shimmer_3s_linear_infinite]">
                <span className="block w-full h-full bg-background rounded-none" />
              </span>
              
              {}
              <span className="relative flex items-center gap-3 z-10 font-bold font-default">
                <Loader2 className="w-5 h-5 text-primary animate-spin" />
                <span className="animate-pulse">LOADING SYSTEM</span>
              </span>
              
              {}
              <span className="absolute inset-0 bg-primary/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </Link>
          </Button>
        </div>

      </div>

      {}
      
      <div className="absolute bottom-10 right-10 hidden md:block text-right">
        <div className="flex gap-1 justify-end mb-2">
          <div className="w-6 h-6 bg-secondary/30 rotate-45 border border-secondary shadow-[0_0_10px_rgba(255,255,255,0.1)]" />
        </div>
        <div className="text-[10px] font-default text-secondary tracking-widest">STRUCTURAL ANCHOR v1.0</div>
      </div>

    </section>;
}